// extracted by mini-css-extract-plugin
module.exports = {"qv-drawer":"quick-view-drawer_qv-drawer__aipdG","qv-drawer__button":"quick-view-drawer_qv-drawer__button__eggBp"};